export const zh = {
    hello: "你好",
    User_log_in: "用户登录",
    Access_key: "访问密钥",
    Public_Mode_1: "公开模式",
    Public_Mode_2:
    "此模式提供配置程序的全部功能。可以创建和保存项目，并可以下载生产文件。但是在公共模式下，任何人无需访问密钥均可以查看、编辑和删除这些项目。",
    Private_Workspace_1: "私人工作区",
    Private_Workspace_2:
    "可以创建和保存项目，并可以下载生产文件。只有通过访问密钥才能查看、编辑和删除这些的项目。要申请免费的访问密钥，请通过 T4Tsupport@inventronicsglobal.com 注册。同一个组织团体应共享一个工作区。",
    Help: "帮助",
    Log_In: "登录",
    Signed_in_as: "已登录",
    Version: "版本",
    Luminaire_Configurator: "灯具配置程序",
    Create_New_Project: "创建新项目",
    Open_file: "打开文件",
    from_computer: "从计算机",
    Open_project: "打开项目",
    from_cloud: "从云端",
    Recent_Projects: "近期项目",
    Status: "状态",
    Project_Name: "项目名称",
    Update_Date: "更新日期",
    Select_Device: "选择设备",
    SHOW_ALL: "显示全部",
    INDOOR_ONLY: "仅室内",
    OUTDOOR_ONLY: "仅户外",
    Advanced_filters: "高级筛选",
    Programming_Interface: "编程接口",
    Show_only_newest_FW_versions: "仅显示最新固件版本",
    Show_only_favourites: "仅显示收藏",
    Driver: "驱动电源",
    Summary: "概述",
    Operating_Mode: "工作模式",
    Current_Mode: "电流模式",
    Fixed_Current: "电流设置",
    Minimum_Current: "最小电流",
    Operating_Current: "工作电流",
    Maximum_Current: "最大电流",
    Good_Performance_Area: "良好工作区域",
    Programmed_Operating_Area: "编程工作区域",
    Allowed_Operating_Area: "允许工作区域",
    Current_graph: "电流 [mA]",
    Voltage_graph: "电压 [V]",
    Adjustable_Dim: "调光曲线可调",
    Dim_to_Off: "调光关断",

    Airborne: "调光信号异常处理",
    Typical_curves: "典型曲线",
    Graph: "曲线图",
    Enable_Disable_DimOnOff: "启用",
    Constant_Lumen: "光衰补偿",
    Levels_Times: "亮度和时间",
    Energy_Saving_Potential: "节能潜力",
    End_Life: "寿命到期预警",
    Power_Settings: "功率设置",
    Driver_Guard: "过温保护",
    Thermal_Settings: "热保护设置",
    PWM_Dim: "PWM 调光",
    Submode: "子模式",
    Astro_Based: "基于天文时间",
    RTC_Based: "基于实时时钟",
    Time_Based: "基于时间间隔",
    SD_triggered: "外部感应触发",
    Fade_Timing: "调光渐变时间",
    Switch_On_Fade_Time: "开启渐变时间",
    AstroDIM_Fade_Time: "调光渐变时间",
    Switch_Off_Fade_Time: "关灯渐变时间",
    Location: "地理位置",
    Reference_Schedule: "参考时间排程",
    Preset_Profiles: "预设配置文件",
    Energy_Savings: "节能",
    Loaded_Data: "读取的数据",
    Loaded_Data_Info: "本项目由设备读取数据载入。切换子模式会将时间表替换为默认值；此操作会将本页所有设置恢复为从驱动器读取的数值。",
    Reset_To_Loaded_Data: "恢复为读取的数据",
    Output_Level: "输出等级",
    Time: "时间",
    Custom: "自定义",
    Positive: "正逻辑",
    Negative: "负逻辑",
    Dimming: "调光",
    Operating_Time: "运行时间",
    Cons_Lum_Eng_Savings: "不支持计算节能潜力",
    Up_to: "高达",
    energy_saving_in: "节能",
    More_info: "详细信息",
    Less_info: "简要信息",
    Warning: "警告",
    Are_you_sure_remove_driver: "你确定要删除该驱动器吗？",
    from_the_project: "从该项目中?",
    Yes: "是",
    No: "否",
    Delete_driver: "删除驱动器",
    Order_code: "订货编码",
    Basic_Code: "基本代码",
    Description: "描述",
    Customer_Project: "客户/项目",
    numberOfDevices: "# 设备数量",
    Serial_Number: "系列号",
    FW_Version: "固件版本",
    Driver_Count: "驱动器数量",
    Change_Image: "更改图像",
    Datasheet: "规格书",
    Maximum_Output_Current: "最大输出电流",
    Minimum_Output_Current: "最小输出电流",
    Slow: "慢速",
    FixedCurrent: "固定电流",
    Latitude: "经度",
    Longitude: "维度",
    Time_Zone: "时区",
    MidNight_Shift: "午夜时间偏移",
    Save_as: "另存为",
    Rename: "重命名",
    Saving: "存储中",
    Change_project_name: "更改项目名称",
    Download: "下载",
    Downloading: "下载中",
    Finish_and_download: "完成并下载",
    Consistent_with_the_dimming_logic: "与调光逻辑一致",
    Temperature: "温度",
    Linear: "线性",
    Logarithmic: "对数",
    // am58968 spells the dd-file enum label lowercase
    logarithmic: "对数",
    Fade: "渐变",
    Extended_Fade_Time: "扩展渐变时间",
    Fade_Time: "渐变时间",
    Fade_Rate: "渐变速率",
    Limits: "限值",
    Min_Level: "最小亮度",
    Max_Level: "最大亮度",
    Level: "等级",
    Use_last_stored_level_on_Power_ON: "调用上次通电时储存的亮度",
    Dont_change_existing_level_on_System_Failure: "故障发生时不改变当前亮度",
    Address: "地址",
    Groups: "分组",
    Scenes: "场景",
    Dali_Addressing: "DALI 地址编译",
    Dexal_Power_Supply_Unit: "DALI 总线供电模块",
    Supply_On_Mains_Off: "断电时的供电方式",
    Maintain_Supply: "尽量维持供电",
    Maintain_Supply_Subtitle: "（缓慢关闭）",
    Immediate_Off: "立即断电",
    Parameters: "参数",
    Identification_Number: "识别码",
    GTIN: "国际贸易货品编码 GTIN",
    General: "常规",
    Content_Format_ID: "内容格式识别码 ID",
    Use_programming_date: "使用烧录时的日期",
    Year: "年",
    Week: "周",
    Light_Distribution: "光分布",
    Light_distribution_type: "光分布类型",
    Generate_unique_number_per_driver: "根据每个驱动电源生成唯一的代码",
    Additional_luminaire_information: "额外的灯具信息",
    max: "限",
    chars: "个字",
    Luminaire_color: "灯具颜色",
    Rated_Median_Useful_Life_of_Luminaire: "灯具额定平均使用寿命 (ta=25°C)",
    Internal_Control_Gear_Reference_Temperature: "内部驱动器参考温度 (ta=25°C)",
    Rated_Median_Useful_Light_Source_Starts: "光源额定平均使用寿命",
    NominalInputPower: "标称输入功率",
    PowerAtMinimumDimLevel: "最低调光亮度时的功率",
    NominalMinimumACMainsVoltage: "最低交流输入电压标称值",
    NominalMaximumACMainsVoltage: "最高交流输入电压标称值",
    NominalLightOutput: "光输出标称值",
    ColorRenderingIndex: "显色性",
    CorrelatedColorTemperature: "色温",
    OEMName: "配套生产厂名称",
    StockingNumber: "存货编码",
    LampCurrent: "光源电流值",
    CustomerUse: "Customer Use",
    Configuration_Lock: "配置锁",
    Access_to_Features: "可访问的特性",
    Everyone: "所有人",
    Operating_Modes: "工作模式",
    End_of_Life: "寿命到期预警",
    Dimming_Levels: "调光等级",
    Luminaire_Info_and_DEXAL_PSU: "灯具信息和DEXAL供电",
    Select_all: "全选",
    Cancel: "取消",
    Select: "选择",
    Selection: "已选择型号",
    New_Project_name: "新项目名称",
    Save: "保存",
    You_have_not_set_up_a_password_line_1: "您没有为这个灯具的配置密码保护。",
    You_have_not_set_up_a_password_line_2:
    "我们强烈建议设置密码，以避免意外或未经授权的关键参数调整而导致可能的损坏或灯具的不安全使用。",
    You_have_not_set_up_a_password_line_3: "同时，还需考虑参数调整对灯具认证的有效性影响。",
    Continue_anyways: "仍然继续",
    Programming_Options: "编程选项",
    Program_As: "编程为",
    Master: "主管",
    Service: "服务商",
    User: "用户",
    If_target_driver_is_protected: "如果目标驱动被锁定保护，可使用以下主密码来解锁编程。",
    key: "密钥",
    master: "主",
    Verify_parameters_after_programming: "编程后校验参数",
    Disable_Family_Programming: "禁止整箱（多个）同时编程",

    Luminaire_Info: "灯具信息",
    Emergency_Mode: "应急模式",
    Tuning_Factor__Level: "调节系数/等级",
    Tuning_Factor__Limits___Lumen: "调节系数/流明限制",
    Dim_to_Dark: "调暗至熄灭",
    Soft_Switch_Off: "软关闭",
    Power_On_Level: "开机亮度等级",
    Loss_Dim_Data: "调光数据丢失",
    Enable_Disable: "启用/禁用",

    Off_Low: "关/低",
    On_High: "开/高",
    Detect: "检测",
    Pull_Up_Current_Selection: "调光线电流源",
    Auxiliary_Voltage_Selection: "辅助电压选择",
    Input_Voltage: "输入电压",
    Protection: "保护",
    Recovery: "恢复",
    Under_Voltage: "欠压",
    Over_Voltage: "过压",
    Auxiliary_Voltage: "辅助电压",

    Operation_Mode_Not_Programmed: "请注意，工作模式不会被写入电源",
    Driver_Compatibility_Warning: "请注意，T4T不会验证电源与LED模组的兼容性",
    Unsaved_Project_Warning: "您还未完成所有必填项，您的项目会被删除。您确定要退出？",
    Imprint: "版本说明",
    Terms_of_Use: "使用条款",
    Privacy_Policy: "隐私政策",
    Open_Source_Licenses: "打开源文件序列号",
    Contacts: "联系方式",
    Logging_in: "登录",
    Tuner4TRONIC: "Tuner4TRONIC",
    Access_Key_Error: "请输入正确的访问密钥或使用公开模式",
    Leave_This_Page: "离开本页面",
    Confirmation: "确认",
    Logout_Access_Key_Warning: "请注意如您继续推出，登录您私人工作区的访问密钥将从浏览器删除",
    Continue: "继续",
    Ok: "好的",
    Error: "错误",
    Projects: "项目",
    Delete_Project_Confirmation: "您确定要删除本项目吗",
    Filter: "筛选",
    Filter_by_interface: "根据接口筛选",
    Filter_by_ECG_type: "根据ECG类型筛选",
    All: "全部",
    Errors: "错误",
    Warnings: "警告",
    Thermal_Protection: "热保护",
    FR_Arrete_nuisances_lumineuses: "法国关于光污染的行政令",
    FR_Warning_Profile:
    "警告：预设曲线符合法国法律要求“法国关于光污染的行政令”，该法令关于灯具安装在巴黎，在日出日落时开关灯且夜里平均中点在00：45。 数值需要根据项目特性调整。英飞特对误使用的情况不承担责任。首次上电仅用于校准。",
    Mask_CH1: "隐藏CH1",
    Mask_CH2: "隐藏CH2",
    Mask_CH3: "隐藏CH3",
    Mask_CH4: "隐藏CH4",
    Partial: "部分的",
    Locked_Features: "锁定的特性",
    Power_On_Behaviour: "上电动作",
    Light_Controls: "控制",
    Switch_ON_OFF_Short_Push: "开/关（短按）",
    Dim_UP_DOWN_Long_Push: "调亮/调暗（长按）",
    Set_Reset_level_Double_Push: "设置/重置（双击）",
    Mains_Frequency: "供电频率",
    Operative: "运行",
    Fade_Time_1: "渐变时间[1]",
    Operative_Level: "运行亮度等级",
    Hold_Time_2: "保持时间[2]",
    Fade_Time_3: "渐变时间[3]",
    DALI_Level: "DALI等级",
    Hold_Time_4: "保持时间[4]",
    Fade_Time_5: "渐变时间[5]",
    Hold_Time_6: "保持时间[6]",
    Fixed_Current_CH2: "固定电流 CH2",
    Luminous_Flux: "光通量",
    Tuning_Factor: "调节系数",
    Limits_and_Reference_Lumen: "限制和参考流明数",
    Tuning_Level: "调节等级",
    Colour_Temperature: "色温",
    Use_last_stored_colour_temperature: "调用上次通电时储存的亮度",
    LED_Module_Configuration: "LED模组设置",
    Physical_Coldest: "物理最高色温",
    Physical_Warmest: "物理最低色温",
    Colour_Temperature_Range: "色温范围",
    Coldest: "最高",
    Warmest: "最低",
    Dim_Settings: "调光设置",
    Dim_To_Dark: "调光至熄灭",
    Settings: "设置",
    Architectural_Features: "架构特性",
    Low_Level_Dimming_Mode: "低亮度时调光模式",
    Dimming_Mode: "调光模式",
    Max_Power: "最大功率",
    DC_Mains_Emergency_Mode: "DC供电->应急模式",
    Close: "关闭",
    Load_LED_Module: "加载LED模组",
    Ambient: "环境",
    Modularity_serial: "组合（串联）",
    Count: "数量",
    Cold_White_CH1: "冷白 CH1",
    Module_Temperature: "模组色温",
    Color_X: "色温_X",
    Color_Y: "色温_Y",
    Color_Temperature: "色温",
    Warm_White_CH2: "暖白 CH2",
    Maximum_nominal_input_power: "最大标称输入功率",
    Initial_luminous_flux: "初始光通量",
    Correlated_color_temperature: "相关色温",
    Color_rendering_index: "显色指数",
    Start_Level: "起始等级",
    Channel_1: "通道 1",
    Channel_2: "通道 2",
    Permanent_Shut_Down: "永久性关断",
    Power_On_Delay: "DALI 上电延迟",
    Custom_Power_On_Delay: "Custom 自定义上电延迟",
    Output_Levels: "输出亮度",
    Keep_Astro_Dim_color: "保持Astro Dim色温",
    PD_Timing: "存在感应定时",
    PD_Sensor_type_label: "存在检测传感器类型",
    PWM_Dimming_Mode: "PWM调光模式",
    Mode: "模式",
    Normalized: "标准",
    Extended: "扩展",
    Repeater: "中继器",
    Mode_Settings: "模式设置",
    Phys_Min_level: "物理最低亮度",
    Min_Level_Auto_Detection: "最低亮度自动检测",
    Nominal_Level: "标准亮度",
    SD_Level: "阶梯调光等级",
    Switch_On_Timing: "上电定时",
    SD_Timing: "阶梯调光定时",
    Sensor_Type: "感应器类型",
    Resistor_Based: "基于热敏电阻",
    Temperature_Based: "基于温度传感器",
    Start_Derating: "开始降额",
    End_Derating: "停止降额",
    Shut_Off: "关断",
    Derating_Level: "降额等级",
    Light_Level_Control_Button_1: "调光（按键1）",
    Power_ON_settings: "上电设置",
    Operative_settings: "工作设置",
    Fade_Time_4: "渐变时间[4]",
    Hold_Time_5: "保持时间[5]",
    Sensors: "感应器",
    Light_sensor: "光感",
    Presence_detection: "存在感应",
    Holiday_Mode: "假期模式",
    Auto_disable_Presence_Detection: "自动禁止存在感应",
    Set_Luminaire_reference_light_output: "设置灯具100%输出参考光通量",
    Lumen: "流明",
    Setting: "设置",
    Min_DIM_Level: "最低调光等级",
    Feature: "特性",
    Parameter: "参数",
    Value: "值",
    Unit: "单位",
    PROJECT_WITHOUT_DRIVERS: "无驱动项目",
    Stay: "停留",
    Leave: "离开",
    Fixed_Current_CH1: "固定电流 CH1",
    Use_this_functionality_to_limit_Light_Output: "使用这个功能限制T4T Field APP的输出。记得使用使用配置锁更新访问权限",
    Select_LED_Module: "选择LED模组",
    D2W_Note: "关于最低/最高色温，\n请注意：带DALI接口的D2W编程不会更新物理最低/最高色温设置",
    Dimming_Level: "调光等级",
    Color: "色温",
    Output_Level_Percent: "输出等级（%）",
    Time_h: "时间（h）",
    Time_Elapsed_h: "自启动经过的时间（h）",
    Midnight: "午夜",
    StandBy: "待机",
    Maximum_Limit: "上限",
    Minimum_Limit: "下限",
    Set_Luminaire_Reference: "设置灯具100%输出参考光通量",
    Only_Master: "限主管",
    Service_and_Master: "服务商和主管",
    Dont_change_colour_on_System_Failure: "系统失效时保持现有色温",
    Use_last_stored_colour_temperature_on_Power_ON: "调用上次通电时储存的色温",

    Clear_all: "清除全部",
    Products_News: "产品新闻",
    Read_more: "阅读更多",
    Tunable_White_LED_Module_Configurator: "可调白光LED模组配置器",
    Create_New_Module: "创建新模组",
    Open_Module: "打开模组",
    Frontend_version: "前端版本：",
    Customer: "客户",
    Creation_Date: "创建日期",
    Saving_as_new: "另存为新项目",
    Download_API_Key_Warning: "生产文件下载仅对拥有 API KEY 的用户开放",
    Project_name_placeholder: "项目名称",
    Download_Not_Available_Warning: "公开模式下无法下载生产文件",
    Public_Mode_Privacy_Warning: "作为公开模式的隐私保护措施，文件不会保存到云端",
    Project_saved: "项目已保存",
    Properties_to_update: "个属性待更新",
    Open_in_P4: "在P4中打开",
    Adding_Driver: "正在添加驱动",
    Please_select_Device_Before: "请先选择设备",
    Please_select_Device: "请选择设备",
    Looks_good: "看起来不错！",
    Released_OSRAM_LED_modules: "已发布的 LED模组",
    Customer_LED_modules_removable: "客户LED模组（可移除）",
    Loading: "加载中",
    Modularity_Reset_Warning: "更改模块化设置将重置当前设置为默认值",
    Tdriver_max: "驱动器最高温度",
    StandBy_1: "待机 1",
    StandBy_2: "待机 2",
    Project_Not_Found_Message: "抱歉，项目：'{{url}}' 不可用（对于此用户）。",
    Project_May_Have_Been_Deleted: "该项目可能已被删除。",
    Light_Level_Control_Button_2: "调光（按键2）",
    CCT_Control_Button_2: "色温控制（按键2）",
    Set_Colour_to_middle_Short_Push: "设置色温为中间值（短按）",
    Colour_WARMER_COLDER_Long_Push: "色温变暖/变冷（长按）",
    Set_Reset_Colour_Double_Push: "设置/重置色温（双击）",
    Start_with_active_level: "使用上次断电前的亮度启动",
    Start_with_active_color: "使用上次断电前的色温启动",
    Mains_Power_ON_Level_CH1: "上电亮度 CH1",
    Mains_Power_ON_DALI_Level: "上电 DALI 亮度等级",
    Mains_Power_ON_Level_CH2: "上电 DALI 亮度等级 CH2",
    Mains_Power_ON_Colour: "上电色温",
    Use_active_level_before_Switch_OFF: "使用关闭前的亮度等级",
    Use_active_CCT_before_Switch_OFF: "使用关闭前的色温",
    Kelvin: "开尔文",
    Colour: "色温",
    Mirek: "Mirek",
    the_project: "该项目",
    Download_API_Key_Warning_Full: "生产文件下载功能仅对拥有 API-KEY 的用户开放。请联系您的英飞特销售代表获取更多信息。",
    Download_Errors_Warning: "由于存在一些错误，无法下载生产文件。请修复后重试。",
    Public_Mode_Project_Deleted: "作为公开模式的隐私保护措施，您的项目已下载到您的电脑，但已从云端删除。",
    Premium_Functionality_Text:
    "{{featureName}} 是一项高级功能。您可以使用此功能创建配置文件，但在编程驱动时，将按设备收取费用。",
    Contact_Sales_Representative: "请联系您的英飞特销售代表获取更多信息。",
    power_on_delay_value: "Value",
    anti_flicker: "Anti Flicker",
    pull_up_current_warning: "WARNING: MULT-PRG2 cannot communicate with the driver. If programming is required, a 20K-50K resistor must be added between VCC and DIM+",
    AstroDim_Override_Info: "当检测到0-10V信号时，此调光时间表将被临时覆盖。信号移除后，驱动器将切换回AstroDim时间表。",
    // --- MPPT solar charge controller (am58962) -----------------------------------------
    // English placeholders where Meng can put her translations
    // to en.js through fallbackLng either way, so replacing the value is the only edit.
    // Field labels are ALSO translatable centrally, in the Inventronics translation service
    // (t4tapi TranslationService.LocalizeProperties); a pair added there wins over this file
    // and covers every client. Enum values below it cannot - the server never touches them.
    Battery_Type: "电池类型",
    System_Voltage: "系统电压",
    "12V_Over_Discharge_Voltage": "12V过放电压",
    "12V_Over_Discharge_Return_Voltage": "12V过放返回电压",
    "12V_Charge_Voltage": "12V充电电压",
    "12V_Charge_Return_Voltage": "12V充电返回电压",
    "12V_Boost_Charge_Voltage": "12V升压充电电压",
    "12V_Floating_Charge_Voltage": "12V浮充电压",
    Maximum_Battery_Charging_Current: "电池最大充电电流",
    "24V_Over_Discharge_Voltage": "24V过放电压",
    "24V_Over_Discharge_Return_Voltage": "24V过放返回电压",
    "24V_Charge_Voltage": "24V充电电压",
    "24V_Charge_Return_Voltage": "24V充电返回电压",
    "24V_Boost_Charge_Voltage": "24V升压充电电压",
    "24V_Floating_Charge_Voltage": "24V浮充电压",
    Sleep_Mode: "休眠模式",
    Light_Control_Voltage: "光控电压",
    Light_Control_Delay: "光控延迟",
    Temperature_Protection_Mode: "温度保护模式",
    "T1_for_Charging_stop_(H)": "T1 充电停止(H)",
    "T2_for_Charging_stop_(L)": "T2 充电停止(L)",
    "T3_for_Discharging_stop_(H)": "T3 放电停止(H)",
    "T4_for_Discharging_stop_(L)": "T4 放电停止(L)",
    "T5_for_Charging_Limit_(H)": "T5 充电限制(H)",
    "T6_for_Charging_Limit_(L)": "T6 充电限制(L)",
    "T7_for_Discharging_Limit_(H)": "T7 放电限制(H)",
    "T8_for_Discharging_Limit_(L)": "T8 放电限制(L)",
    Charge_Limit_Current_1: "限制充电电流1",
    Charge_Limit_Current_2: "限制充电电流2",
    Discharge_Limit_Current_1: "限制放电电流1",
    Discharge_Limit_Current_2: "限制放电电流2",
    Output_Derating_Current: "输出降额电流",
    Recovery_Temperature: "恢复温度",
    Protection_Temperature: "保护温度",
    Intelligent_Output_Adjustment: "智能功率控制",
    Derating_Start_Voltage: "降额启动电压",
    Derating_End_Voltage: "降额结束电压",
    Derating_End_Current: "降额结束电流",
    Lighting_Mode: "亮灯模式",
    Sunrise_Time: "日出时间",
    Sunset_Time: "日落时间",
    Enable_Daylight_Saving_Time: "夏令时使能",
    "Region/Time_Zone": "UTC时区",
    Battery_Lead_Resistance_Compensation: "电池线阻抗补偿",
    // Time_Zone (时区) and User (用户) are already defined above and serve here too -
    // repeating them would override the existing translation with an English placeholder.
    // enum values - frontend only, the api does not localize AvailableValues
    "Lead-acid": "铅酸",
    LiFePO: "磷酸铁锂",
    Auto: "自动识别",
    "12V": "12V",
    "24V": "24V",
    "Auto-12V": "自动识别-12V",
    "Auto-24V": "自动识别-24V",
    Battery: "电池",
    LEDs: "LEDs",
    High: "高",
    Middle: "中",
    Low: "低",
    OFF: "关闭",
    PV_Priority: "光伏优先",
    RTC_Time_Priority: "RTC时间优先",
    Both_PV_and_RTC_Time: "同时生效",
};
